// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { titleize } from 'common/utils/helpers';

const ResponseAnalysis = ({ data, comparisonValueLabel }) => {
  const { t } = useTranslation();
  const { minValue, maxValue, average, medianValue, stddevValue, comparisonValue } = data;
  const averageNumber = Number(average);
  const comparisonValueNumber = Number(comparisonValue);

  if (!data) {
    return <p>{t('No data to show')}</p>;
  }

  const averagePercentageChange = `${averageNumber >= comparisonValueNumber ? '+' : '-'}${(
    (Math.abs(comparisonValueNumber - averageNumber) * 100) /
    comparisonValueNumber
  ).toFixed(2)}%`;

  return (
    <div className="response-analysis table-container">
      <h5 className="title is-6">Statistics</h5>
      <table className="table">
        <tbody>
          <tr>
            <th>Min</th>
            <th>Max</th>
            <th>Median</th>
            <th>Mean</th>
            {comparisonValue ? <th>{titleize(comparisonValueLabel)}</th> : null}
            <th>Std. Deviation</th>
          </tr>
          <tr>
            <td>{minValue}</td>
            <td>{maxValue}</td>
            <td>{medianValue}</td>
            <td>
              <span>{average} </span>
              {comparisonValue && (
                <span
                  className={classNames('comparison', {
                    neutral: averageNumber === comparisonValueNumber,
                    positive: averageNumber > comparisonValueNumber,
                    negative: averageNumber < comparisonValueNumber,
                  })}
                >
                  {averagePercentageChange}
                </span>
              )}
            </td>
            {comparisonValue ? <td>{comparisonValue}</td> : null}
            <td>{stddevValue}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

ResponseAnalysis.propTypes = {
  data: PropTypes.shape({
    minValue: PropTypes.string,
    maxValue: PropTypes.string,
    average: PropTypes.string,
    medianValue: PropTypes.number,
    modeValue: PropTypes.string,
    stddevValue: PropTypes.string,
    comparisonValue: PropTypes.string,
  }).isRequired,
  comparisonValueLabel: PropTypes.string,
};

ResponseAnalysis.defaultProps = {
  comparisonValueLabel: '',
};

export default ResponseAnalysis;
